export let list = {};

/**
 * Start timing an event
 * @param  {String} name Name of the timer to start
 */
export function start(name) {
  list = { ...list, [name]: Date.now() };
}

/**
 * Stop a timing event
 * @param  {String} name Name of the timer to stop. Must match a timer name
 * @return {int}         Duration of the timer, in milliseconds, -1 if not found
 */
export function stop(name) {
  if (!list[name]) {
    return -1;
  }

  const duration = Date.now() - list[name];

  removeTimer(name);

  return duration;
}

/**
 * Remove a timing event
 * @param  {String} name Name of the timer to remove.
 */
function removeTimer(name) {
  const newTimers = {};
  Object.keys(list).forEach((key) => {
    if (key === name) {
      return;
    }
    newTimers[key] = list[key];
  });
  list = newTimers;
}

export default {
  start,
  stop,
};
